export const STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
};

export const STATUS_PILL_CLASS = {
  [STATUS.ACTIVE]: "bg-emerald-100 text-emerald-700",
  [STATUS.INACTIVE]: "bg-gray-100 text-gray-600",
};

export const MAX_EVENT_CHUNKS = 3;

export const EVENT_KEYS = [
  { value: "login", label: "Login" },
  { value: "article", label: "Article" },
  { value: "epaper", label: "ePaper" },
];

export const CONDITION_1_KEYS = [
  { value: "login", label: "Login" },
  { value: "dwell", label: "Dwell" },
  { value: "session", label: "Session" },
];

export const CONDITION_2_KEYS = [
  { value: "scroll", label: "Scroll" },
  { value: "session", label: "Session" },
  {value : "unique_pages", label: "Unique Pages"},
];

export const CONDITION_OPERATORS = [
  { value: "=", label: "=" },
  { value: ">=", label: ">=" },
  { value: "<=", label: "<=" },
  { value: ">", label: ">" },
  { value: "<", label: "<" },
];

export const INPUT_CLASS_NAME =
  "mt-2 block w-full rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-900 outline-none placeholder:text-gray-400 focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500";

export const SORTABLE_OPTIONS = {
  animation: 150,
  handle: ".drag-handle",
  ghostClass: "opacity-50",
};

export const LOYALTY_LIST_PATH = "/services/loyalty-program";
export const LOYALTY_ADD_PATH = "/services/loyalty-program/add";
export const BRANDS_ADD_PATH = "/services/loyalty-offers/add";
export const getLoyaltyEditPath = (programId) => `/services/loyalty-program/edit/${programId}`;
export const getLoyaltyOffersEditPath = (brandId) => `/services/loyalty-offers/edit/${brandId}`;
export const getOfferAddPath = (brandId) => `/services/loyalty-offers/${brandId}/offers/add`;
export const getOfferEditPath = (brandId, offerId) => `/services/loyalty-offers/${brandId}/offers/edit/${offerId}`;
export const getCouponAddPath = (brandId, offerId) => `/services/loyalty-offers/${brandId}/offers/${offerId}/coupons/add`;
export const getCouponEditPath = (brandId, offerId, couponId) =>
  `/services/loyalty-offers/${brandId}/offers/${offerId}/coupons/edit/${couponId}`;
